import service from "../../Service/service";

const showCreateOrUpdate = async (payload) => {
    var data = {};
    try {
        service.CreateOrUpdate("Show/CreateOrUpdate", payload).then((res) => {
            if (res.data != undefined) {
                data = res.data;
            }
            else {
                data = "something went wrong"
            }
        })
    } catch (error) {
        console.log(error);
        data = "something went wrong"
    }
    return data;
}

export { showCreateOrUpdate }